import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { featureFlagsService, FeatureFlag } from '@/features/branding/services/feature-flags.service';
import { useAuthStore } from '@/store/auth.store';

const EMPTY_FLAGS: FeatureFlag[] = [];

export function useFeatureFlags() {
  const user = useAuthStore((s) => s.user);

  const { data: flags = EMPTY_FLAGS, isLoading } = useQuery<FeatureFlag[]>({
    queryKey: ['feature-flags', 'my', user?.tenantId],
    queryFn: () => featureFlagsService.listMy(),
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  /**
   * Retorna true se a feature está habilitada.
   * Durante o carregamento retorna false — o menu aguarda isLoading via useMenuAccess.
   */
  const isEnabled = useCallback((featureKey: string): boolean => {
    if (isLoading) return false;
    const flag = flags.find((f) => f.featureKey === featureKey);
    if (!flag) return false; // sem registro = desabilitada por padrão
    return flag.isEnabled;
  }, [flags, isLoading]);

  return { flags, isEnabled, isLoading };
}
